import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  merchantInit: '',
  Event: cloneDeep(initEvent),
  actionEvent: cloneDeep(initEvent),
  staffList: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  roles: [],
  detail: undefined,
  detailEvent: cloneDeep(initEvent),
  merchantPackageList: {
    data: [],
    event: cloneDeep(initEvent),
  },
  packageSpec: {
    data: [],
    event: cloneDeep(initEvent),
  },
  packageSpecByID: {
    data: undefined,
    event: cloneDeep(initEvent),
  },
  packageLogs: {
    data: [],
    event: cloneDeep(initEvent),
  },
  isPackageC: false,
  isPackageEnterprise: false,
  isHasPackage: false,
  config: {
    data: undefined,
    event: cloneDeep(initEvent),
    actionEvent: cloneDeep(initEvent),
  },
  configList: {
    data: [],
    event: cloneDeep(initEvent),
  },
  paymentConfigList: {
    data: [],
    event: cloneDeep(initEvent),
  },
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getMerchantInitAction.request):
        draft.Event = cloneDeep(initEvent)
        draft.Event.IsLoading = true
        draft.merchantInit = ''
        return draft
      case getType(actions.getMerchantInitAction.success):
        response = action.payload
        draft.Event.IsLoading = false
        draft.Event.SubmitSuccess = true
        if (response.data && response.data.status) {
          draft.merchantInit = response.data.status
        } else {
          draft.merchantInit = ''
        }
        return draft
      case getType(actions.getMerchantInitAction.failure):
        draft.Event.IsLoading = false
        draft.Event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.MerchantCreatePackageAction.request):
      case getType(actions.createAction.request):
      case getType(actions.updateAction.request):
      case getType(actions.deleteAction.request):
      case getType(actions.resetPinAction.request):
      case getType(actions.buyPackageAction.request):
      case getType(actions.renewPackageAction.request):
      case getType(actions.activatePackageAction.request):
      case getType(actions.updateStaffStatusAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.MerchantCreatePackageAction.success):
      case getType(actions.createAction.success):
      case getType(actions.updateAction.success):
      case getType(actions.deleteAction.success):
      case getType(actions.resetPinAction.success):
      case getType(actions.buyPackageAction.success):
      case getType(actions.renewPackageAction.success):
      case getType(actions.activatePackageAction.success):
      case getType(actions.updateStaffStatusAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = undefined
          draft.actionEvent.SubmitSuccess = true
          draft.actionEvent.MessageSuccess = 'ทำรายการสำเร็จ'
        } else {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.MerchantCreatePackageAction.failure):
      case getType(actions.createAction.failure):
      case getType(actions.updateAction.failure):
      case getType(actions.deleteAction.failure):
      case getType(actions.resetPinAction.failure):
      case getType(actions.buyPackageAction.failure):
      case getType(actions.renewPackageAction.failure):
      case getType(actions.activatePackageAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = action.payload.message
        return draft
      case getType(actions.updateStaffStatusAction.failure):
        const error = action as any
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = error?.payload?.response?.data?.message || ''
        return draft
      case getType(actions.getStaffListAction.request):
        draft.Event = cloneDeep(initEvent)
        draft.Event.IsLoading = true
        draft.staffList = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getStaffListAction.success):
        response = action.payload
        draft.Event.IsLoading = false
        draft.Event.SubmitSuccess = true
        draft.staffList.data = response.data
        if (response.meta) {
          draft.staffList.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getStaffListAction.failure):
        draft.Event.IsLoading = false
        draft.Event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getRolesListAction.request):
        draft.Event = cloneDeep(initEvent)
        draft.Event.IsLoading = true
        draft.roles = []
        return draft
      case getType(actions.getRolesListAction.success):
        response = action.payload
        draft.Event.IsLoading = false
        draft.Event.SubmitSuccess = true
        draft.roles = response.data
        return draft
      case getType(actions.getRolesListAction.failure):
        draft.Event.IsLoading = false
        draft.Event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getDetailAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.detail = undefined
        return draft
      case getType(actions.getDetailAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        draft.detail = response.data
        return draft
      case getType(actions.getDetailAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getMerchantPackageListAction.request):
        draft.merchantPackageList.event = cloneDeep(initEvent)
        draft.merchantPackageList.event.IsLoading = true
        draft.merchantPackageList.data = []
        return draft
      case getType(actions.getMerchantPackageListAction.success):
        response = action.payload
        draft.merchantPackageList.event.IsLoading = false
        draft.merchantPackageList.event.SubmitSuccess = true
        draft.merchantPackageList.data = response.data
        return draft
      case getType(actions.getMerchantPackageListAction.failure):
        draft.merchantPackageList.event.IsLoading = false
        draft.merchantPackageList.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getPackagesSpecAction.request):
        draft.packageSpec.event = cloneDeep(initEvent)
        draft.packageSpec.event.IsLoading = true
        draft.packageSpec.data = []
        return draft
      case getType(actions.getPackagesSpecAction.success):
        response = action.payload
        draft.packageSpec.event.IsLoading = false
        draft.packageSpec.event.SubmitSuccess = true
        draft.packageSpec.data = response.data
        return draft
      case getType(actions.getPackagesSpecAction.failure):
        draft.packageSpec.event.IsLoading = false
        draft.packageSpec.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getPackagesSpecByIDAction.request):
        draft.packageSpecByID.event = cloneDeep(initEvent)
        draft.packageSpecByID.event.IsLoading = true
        draft.packageSpecByID.data = undefined
        return draft
      case getType(actions.getPackagesSpecByIDAction.success):
        response = action.payload
        draft.packageSpecByID.event.IsLoading = false
        draft.packageSpecByID.event.SubmitSuccess = true
        draft.packageSpecByID.data = response.data
        return draft
      case getType(actions.checkMerchantPackageAction.request):
        draft.isPackageC = false
        draft.isPackageEnterprise = false
        draft.isHasPackage = false
        return draft
      case getType(actions.checkMerchantPackageAction.success):
        response = action.payload
        draft.isPackageC = response.data.status && response.data.level === '3'
        draft.isPackageEnterprise = response.data.status && response.data.name === 'Enterprise (องค์กร)'
        draft.isHasPackage = response.data.status
        return draft
      case getType(actions.getPackagesSpecByIDAction.failure):
        draft.packageSpecByID.event.IsLoading = false
        draft.packageSpecByID.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getPackagesLogAction.request):
        draft.packageLogs.event = cloneDeep(initEvent)
        draft.packageLogs.event.IsLoading = true
        draft.packageLogs.data = []
        return draft
      case getType(actions.getPackagesLogAction.success):
        response = action.payload
        draft.packageLogs.event.IsLoading = false
        draft.packageLogs.event.SubmitSuccess = true
        draft.packageLogs.data = response.data
        return draft
      case getType(actions.getPackagesLogAction.failure):
        draft.packageLogs.event.IsLoading = false
        draft.packageLogs.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.setConfigAction.request):
      case getType(actions.setPaymentConfigAction.request):
        draft.config.actionEvent = cloneDeep(initEvent)
        draft.config.actionEvent.IsLoading = true
        return draft
      case getType(actions.setConfigAction.success):
      case getType(actions.setPaymentConfigAction.success):
        response = action.payload
        if (response?.status?.code === 200) {
          draft.config.actionEvent.IsLoading = false
          draft.config.actionEvent.SubmitError = undefined
          draft.config.actionEvent.SubmitSuccess = true
          draft.config.actionEvent.MessageSuccess = 'บันทึกสำเร็จ'
        } else {
          draft.config.actionEvent.IsLoading = false
          draft.config.actionEvent.SubmitError = response?.message
        }
        return draft
      case getType(actions.setConfigAction.failure):
      case getType(actions.setPaymentConfigAction.failure):
        draft.config.actionEvent.IsLoading = false
        draft.config.actionEvent.SubmitError = action.payload.message
        return draft

      case getType(actions.getConfigAction.request):
        draft.config.event = cloneDeep(initEvent)
        draft.config.event.IsLoading = true
        draft.config.data = undefined
        return draft
      case getType(actions.getConfigAction.success):
        response = action.payload
        draft.config.event.IsLoading = false
        draft.config.event.SubmitSuccess = true
        if (response.data) {
          draft.config.data = response.data
        }
        return draft
      case getType(actions.getConfigAction.failure):
        draft.config.event.IsLoading = false
        draft.config.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getConfigListAction.request):
        draft.configList.event = cloneDeep(initEvent)
        draft.configList.event.IsLoading = true
        draft.configList.data = []
        return draft
      case getType(actions.getConfigListAction.success):
        response = action.payload
        draft.configList.event.IsLoading = false
        draft.configList.event.SubmitSuccess = true
        draft.configList.data = response.data
        return draft
      case getType(actions.getConfigListAction.failure):
        draft.configList.event.IsLoading = false
        draft.configList.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getPaymentConfigListAction.request):
        draft.paymentConfigList.event = cloneDeep(initEvent)
        draft.paymentConfigList.event.IsLoading = true
        draft.paymentConfigList.data = []
        return draft
      case getType(actions.getPaymentConfigListAction.success):
        response = action.payload
        draft.paymentConfigList.event.IsLoading = false
        draft.paymentConfigList.event.SubmitSuccess = true
        draft.paymentConfigList.data = response.data
        return draft
      case getType(actions.getPaymentConfigListAction.failure):
        draft.paymentConfigList.event.IsLoading = false
        draft.paymentConfigList.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.clearEventAction):
        draft.Event = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        draft.config.actionEvent = cloneDeep(initEvent)
        draft.paymentConfigList.event = cloneDeep(initEvent)
        return draft
      default:
        return state
    }
  })
}
